export default [
    ['1', '一体化'],
    ['2', '分析态'],
    ['3', '设计态'],
]
